// Image block — factory + serializer. This is the single source of truth
// for what an image block persists (see "Block capability contract" in
// ../PLAN.md). The grid never asserts this shape itself.
import { IMAGE_RESOURCES } from './ImageBlockLayer';

let idCounter = 0;
const nextId = () => `image_${Date.now()}_${idCounter++}`;

export function createImageBlock(overrides = {}) {
  return {
    id: nextId(),
    // Enum key into a fixed set of built-in images, not raw image data —
    // there's no upload pipeline yet (see blocks/image-block.md).
    resourceKey: IMAGE_RESOURCES.DEFAULT_LOGO,
    x: 0.1,
    y: 0.1,
    width: 1,
    height: 1,
    ...overrides,
  };
}

export function serializeImageBlock({ id, resourceKey, x, y, width, height }) {
  return { type: 'image', id, resourceKey, x, y, width, height };
}
